
import type { PropType } from 'vue'
import type { PaymentRequest, WaybillByPaymentRequest } from '@/modern/modules/m-accounting-module/services/types/payment-requests.types'
import type { FullFTLOrderT } from '@/core/types/orders.types'

import { defineComponent } from 'vue'

// > helpers/formatPriceToTenge <
import formatPriceToTenge from '@/modern/helpers/formatPriceToTenge'

export default defineComponent({
    props: {
        paymentRequest: {
            type: Object as PropType<PaymentRequest>,
            required: true
        },
        waybill: {
            type: Object as PropType<WaybillByPaymentRequest | null>,
            default: null,
        },
        ftlOrder: {
            type: Object as PropType<FullFTLOrderT | null>,
            default: null
        }
    },
    setup(props) {
        const calculateFtlOrderAdditionalServicesCost = () => {
            if (!props.ftlOrder) return 0

            if (props.ftlOrder.shared_additional_service.length > 0) {
                const total = props.ftlOrder.shared_additional_service.reduce((sum, service) => sum + Number(service.cost_total || 0), 0)
                return total
            }

            return 0
        }

        const calculateFtlOrderTotalCost = () => {
            if (!props.ftlOrder) return 0

            const servicesCost = calculateFtlOrderAdditionalServicesCost()
            return servicesCost + props.ftlOrder.cost_total
        }

        return {
            formatPriceToTenge,
            calculateFtlOrderAdditionalServicesCost,
            calculateFtlOrderTotalCost,
        }
    }
})
